/**
 * 接口结果判定。
 *
 * httpRequest 从不 reject（见 service/index.js）：业务失败（isError）时它自己弹一次
 * 错误提示后 resolve 出 { code, msg }，网络异常 resolve 空对象并跳错误页。所以「成没成」
 * 必须自己判 code——只靠 try/catch 会把失败也当成功往下走，照着弹「已保存」这类提示。
 */
import { message } from 'ant-design-vue'

/** 成功的 code，照项目里其它模块的口径（多数是 0，少数接口回 200） */
const OK_CODES = ['0', '200']

/**
 * 接口是否成功。
 *
 * 只有明确回了非 0 / 200 的 code 才算失败——个别接口不回 code，这种情况按成功走，
 * 与加这层判定之前的行为一致，不至于把本来能用的接口判成失败。
 *
 * @param {Object} res httpRequest 的返回
 * @returns {boolean}
 */
export const isOk = (res) => res?.code === undefined || OK_CODES.includes(String(res.code))

/**
 * 失败提示。
 *
 * key 与拦截器里那条一致：两处都弹时会合并成一条，不叠两层；有后端文案就用后端的，
 * 没有才退回调用方给的兜底文案。
 *
 * @param {Object} res httpRequest 的返回
 * @param {string} fallback 后端没给 msg 时的兜底文案
 */
export const noticeFail = (res, fallback) =>
  message.error({ content: res?.msg || fallback, key: 'errorMessage' })
